var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"py-3"},[(_vm.text)?_c('div',{staticClass:"title colorTitle"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100 divider",class:_vm.dash ? 'dash' : ''})])])}
var staticRenderFns = []

export { render, staticRenderFns }